const ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  SUPER_MANAGER: 'SUPER_MANAGER',
  SALES_ADMIN: 'SALES_ADMIN',
  SALES: 'SALES',
  SUPPORT: 'SUPPORT',
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  MEMBER: 'MEMBER',
};

export default ROLES;
